import { storage } from './storage';

export interface SystemLog {
    id: number;
    type: 'success' | 'error' | 'warning' | 'info';
    message: string;
    details?: string;
    timestamp: string;
}

const KEYS = {
    SYSTEM_LOGS: 'sbaj_system_logs'
};

export const systemLogService = {
    getLogs: (): SystemLog[] => {
        return storage.get<SystemLog[]>(KEYS.SYSTEM_LOGS, []);
    },

    addLog: (type: 'success' | 'error' | 'warning' | 'info', message: string, details?: string) => {
        const logs = systemLogService.getLogs();
        const newLog: SystemLog = {
            id: Date.now(),
            type,
            message,
            details,
            timestamp: new Date().toISOString()
        };
        // Keep only last 100 logs
        const updatedLogs = [newLog, ...logs].slice(0, 100);
        storage.set(KEYS.SYSTEM_LOGS, updatedLogs);
        return newLog;
    },

    clearLogs: () => {
        storage.set(KEYS.SYSTEM_LOGS, []);
    }
};
